module.exports = __webpack_public_path__ + "static/media/edit-img.97d2f4a6.svg";